var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-form",
        {
          ref: "pageForm1",
          staticClass: "page-form",
          attrs: { model: _vm.Business, rules: _vm.pageRules1 },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Business")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "BusinessName", label: "Business Name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Business.BusinessName,
                          callback: function ($$v) {
                            _vm.$set(_vm.Business, "BusinessName", $$v)
                          },
                          expression: "Business.BusinessName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "BusinessRegistrationNumber",
                        label: "Business Registration Number",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Business.BusinessRegistrationNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.Business,
                              "BusinessRegistrationNumber",
                              $$v
                            )
                          },
                          expression: "Business.BusinessRegistrationNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "JurisdictionOfIncorporation",
                        label: "Jurisdiction Of Incorporation",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Business.JurisdictionOfIncorporation,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.Business,
                              "JurisdictionOfIncorporation",
                              $$v
                            )
                          },
                          expression: "Business.JurisdictionOfIncorporation",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "pageForm2",
          staticClass: "page-form",
          attrs: { model: _vm.Location, rules: _vm.pageRules2 },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Location")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "City", label: "City" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.City,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "City", $$v)
                          },
                          expression: "Location.City",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "PostalCode", label: "Postal Code" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.PostalCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "PostalCode", $$v)
                          },
                          expression: "Location.PostalCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Address1", label: "Address 1 " } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.Address1,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "Address1", $$v)
                          },
                          expression: "Location.Address1",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "pageForm3",
          staticClass: "page-form",
          attrs: { model: _vm.Communication, rules: _vm.pageRules3 },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Communication")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Telephone", label: "Telephone Number" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Communication.Telephone,
                          callback: function ($$v) {
                            _vm.$set(_vm.Communication, "Telephone", $$v)
                          },
                          expression: "Communication.Telephone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }